import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';
import UserService from '../../../../Services/userService';

export default class ExcludedTpJobPayEvaluatorsSearchParams extends SearchParamsBase {
  initialize() {
    this.SearchType = 'excluded';
    this.ThirdPartyJobId = '';
    this.SelectedCaspianClientIds = [];
    this.ProjectIdOrName = '';
    this.SelectedTpJobCountryCodes = [];
    this.EvaluatorNameOrId = '';
    this.EvaluatorEmail = '';
    this.SelectedFieldworkOfficeIds = [];
    this.SelectedPaymentOfficeIds = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
  }

  static fieldsInSearchBox = [
    { fieldName: 'ThirdPartyJobId', label: 'Third-Party Job ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedCaspianClientIds',
      label: 'Client',
      className: 'col-4',
      type: InputTypesEnum.ClientMultiChoice,
    },
    { fieldName: 'ProjectIdOrName', label: 'Project Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedTpJobCountryCodes',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedFieldworkOfficeIds',
      label: 'FW Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedPaymentOfficeIds',
      label: 'Payment Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'EvaluatorNameOrId', label: 'Evaluator Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'EvaluatorEmail', label: 'Evaluator Email', className: 'col-4', type: InputTypesEnum.Text },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'ExcludedTpJobPayEvaluatorsSearchParams';
}
